import { SensorParameter } from "@/global/interface/device/sensor"
import "./index.less"
import { useEffect, useState } from "react"
import { LineChart } from "@/global/components/line-chart"
import { queryInfluxDataList } from "@/api/influx/influx"
import { TimeValue } from "@/global/interface/time-value"
import classNames from "classnames"
import { ReactComponent as CloseSvg } from "@/global/components/sensor-collection-data-panel/icons/close.svg"
import { getMonitorParametersBySensorId } from "@/api/monitor-object/monitor-parameter"
import { MonitorParameter } from "@/global/interface/monitor-object/monitor-parameter"
import { MONITORING_DATA_TYPE } from "@/enums/monitoring-data-type"

interface Iprops {
    setShow: (e) => void,
    params: SensorParameter[],
    sensorId: number
}

interface MyParam {
    id: number,
    symbol: string,
    type: string,
    unit: string,
    name: string
}

export default function SensorCollectionDataPanel(props: Iprops) {

    const [dataList, setDataList] = useState<number[][]>([])

    const [tabItems, setTabItems] = useState<MyParam[]>([])

    const [activeItem, setActiveItem] = useState<MyParam>(null)

    useEffect(() => {
        if (!(props.params?.length > 0)) return () => { }
        generateData()
        setActiveItem({
            id: props.params[0].id,
            type: MONITORING_DATA_TYPE.SENSOR,
            unit: props.params[0].unit,
            name: props.params[0].name,
            symbol: props.params[0].symbol,
        })
        const interval = setInterval(() => {
            generateData()
        }, 5000)

        return (() => {
            clearInterval(interval)
        })
    }, [props])

    useEffect(() => {
        if (!activeItem) return
        generateActiveParamData()
    }, [activeItem])

    const generateActiveParamData = () => {
        queryInfluxDataList(activeItem.id, activeItem.symbol, activeItem.type).then(res => {
            let valueList: TimeValue[] = res.data || []
            // 组合成数据
            let data = []
            for (let i = 0; i < valueList?.length; i++) {
                data.push([valueList[i].time, valueList[i].value])
            }
            setDataList(data)
        })
    }



    const generateData = () => {
        // 获取有关的间接监测参数
        if (!props.sensorId) return
        getMonitorParametersBySensorId(props.sensorId).then(res => {
            let paramList: MonitorParameter[] = res.data || []
            let midList: MyParam[] = []
            for (let i = 0; i < paramList.length; i++) {
                midList.push({
                    id: paramList[i].id,
                    type: MONITORING_DATA_TYPE.MONITOR_OBJ,
                    unit: paramList[i].unit,
                    name: paramList[i].name,
                    symbol: paramList[i]?.symbol || paramList[i].code,
                })
            }
            setTabItems(midList)
        })
    }

    const getChartAxisXLabel = (value: number) => {
        const date = new Date(Number(value));
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }

    const getChartAxisYLabel = (value: number) => {
        return parseFloat(value.toFixed(2)).toString()
    }

    return (
        <div className="sensor-collection-panel">
            <div className="left-body">
                <div className="collection-title">
                    数据面板
                </div>
                <div className="param-list">
                    {props.params?.map((item, index) => (
                        <div className={classNames({
                            "list-item": true,
                            "list-item-active": activeItem?.id == item.id && activeItem?.symbol == item.symbol
                        })} key={index}
                            onClick={() => {
                                setActiveItem({
                                    id: item.id,
                                    type: MONITORING_DATA_TYPE.SENSOR,
                                    unit: item.unit,
                                    name: item.name,
                                    symbol: item.symbol,
                                })
                            }}
                        >
                            {item.name}
                        </div>
                    ))}
                </div>
            </div>
            <div className="right-body">
                <div className="tab-area">
                    {tabItems?.map((tabItem) => (
                        <div
                            className={classNames({
                                "tab-item": true,
                                "tab-item-active": activeItem?.id == tabItem.id && activeItem?.type == tabItem.type
                            })}
                            onClick={() => { setActiveItem(tabItem) }}
                        >
                            <div className="tab-name">
                                {tabItem.name}
                            </div>
                        </div>
                    ))}
                    <CloseSvg className="close-btn" onClick={() => { props.setShow(0) }} />
                </div>
                <div className="data-chart">
                    <LineChart
                        lineData={dataList}
                        getAxisXLabel={getChartAxisXLabel}
                        getAxisYLabel={getChartAxisYLabel}
                        xLabel="时间"
                        toolTipXLabel="时间"
                        noBackground={true}
                        yLabel={activeItem?.unit}
                        toolTipYLabel={activeItem?.name}
                    />
                </div>
            </div>
        </div>
    )
}